import { render, staticRenderFns } from "./LeaveHospitalDetail.vue?vue&type=template&id=682c7604&scoped=true"
import script from "./LeaveHospitalDetail.vue?vue&type=script&lang=js"
export * from "./LeaveHospitalDetail.vue?vue&type=script&lang=js"
import style0 from "./LeaveHospitalDetail.vue?vue&type=style&index=0&id=682c7604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682c7604",
  null
  
)

export default component.exports